import Isotope from 'isotope-layout'

$.fn.ProjectDetails = function(overlay) {
  let self = this
  self.tab = self.find('.project-details__tab')
  self.list = self.find('.project-details__list')
  self.scrolled_start = undefined
  self.scrolled_pixels = 0

  self.scrolled = function(top) {
    if (self.scrolled_start == undefined) {
      self.scrolled_start = top
    }
    let scrolled_diff = top - self.scrolled_start
    if ((scrolled_diff > 100 || scrolled_diff < -100) && !$.mlmi.mobile.matchesMedia()) {
      self.close()
    }
  }

  self.close = function() {
    self.attr('aria-expanded', 'false')
    self.scrolled_pixels = 0
    self.scrolled_start = undefined
    $('html').off('click', self.clicked_outside)
    overlay.el.scroller.scrollEvents.removeCallback(self.scrolled)
  }

  self.open = function() {
    self.attr('aria-expanded', 'true')
    overlay.el.scroller.scrollEvents.add(self.scrolled)
    $('html').on('click', self.clicked_outside)
  }

  self.clicked_outside = function(e) {
    if (!$(e.target).closest('.project-details').length) {
      self.close()
    }
  }

  self.toggle_details = function() {
    if (self.attr('aria-expanded') === 'false') {
      let totalHeight = 0
      self.list.find('dl').each(function() {
        totalHeight += $(this).outerHeight(false)
      })
      self.list.css('max-height', totalHeight + 'px')
      self.open()
    } else {
      self.list.css('max-height', '')
      self.close()
    }
  }

  return function() {
    self.tab.on('click', self.toggle_details)
    return self
  }()
}

$.fn.PanoramaList = function(lists) {
  let self = this
  self.grid = self.find('.grid')
  self.items = self.find('.grid__item')

  self.sort = function(sorting) {
    self.items.detach()
    self.items.sort(function(a, b) {
      if (sorting == 'random') {
        return Math.random() <= .5 ? 1 : -1
      }
      let dateA = $(a).find('.card-lists').attr('data-publish'),
      dateB = $(b).find('.card-lists').attr('data-publish')
      return $(a).find('.card-lists').attr('data-publish').localeCompare($(b).find('.card-lists').attr('data-publish'));
    })
    self.items.appendTo(self.grid)
  }

  return function() {
    return self.BlockElement()
  }()
}

$.fn.PanoramaLists = function() {
  let self = this
  self.lists = []

  self.filter_lists = function(filtering, sorting) {
    self.fadeOut(33, function() {
      self.lists.forEach(function(list) {
        if (filtering == 'all') {
          list.attr('aria-hidden', '')
        } else {
          list.attr('aria-hidden', list.attr('data-filter') == filtering ? 'false' : 'true')
        }
        list.sort(sorting)
        self.fadeIn(300)
      })
    })
  }

  return function() {
    self.find('.panorama-list').each(function() {
      let list = $(this).PanoramaList(self)
      self.lists.push(list)
    })
    return self
  }()
}

$.fn.SectionFilter = function() {
  let self = this

  if (self.data('section-filter')) {
    return self.data('section-filter')
  }

  self.fields = self.find(':input')
  self.value = self.find(':input:checked').val()

  self.changed = function(e) {
    if (self.value != self.find(':input:checked').val()) {
      self.value = self.find(':input:checked').val()
      self.trigger('value_changed')
    }
  }

  self.val = function() {
    return self.find(':input:checked').val()
  }

  return function() {
    self.fields.on('change', self.changed)
    self.data('section-filter', self)
    return self
  }()
}

$.fn.SectionSort = function() {
  let self = this

  if (self.data('section-sort')) {
    return self.data('section-sort')
  }

  self.fields = self.find(':input')
  self.dropdown = undefined
  self.selected = undefined
  self.value = self.find(':input:checked').val()

  self.initialize_dropdown = function() {
    if (!$.mlmi.mobile.matchesMedia()) {
      self.find('.section-sort__item').wrapAll('<div class="section-sort__items"></div>')
      self.dropdown = self.find('.section-sort__items')
      self.selected = self.find('.section-sort__item:first').clone().addClass('section-sort__item--selected')
      self.selected.find('.section-sort__input').remove()
      self.dropdown.before(self.selected)
      self.attr('aria-expanded', 'false').on('click', self.clicked)
      self.find('.section-sort__item label').on('click', function(e) {
        if ($(this).is($(e.target)) && $(this).find('input:checked').length) {
          self.close()
        }
      })
      $('body').on('click', self.close)
    }
    self.fields.on('change', self.changed)
  }

  self.clicked = function() {
    if (self.attr('aria-expanded') === 'true') {
      self.attr('aria-expanded', 'false')
    } else {
      self.attr('aria-expanded', 'true')
    }
  }

  self.close = function(e) {
    if (e == undefined) {
      self.attr('aria-expanded', 'false')
    } else {
      let target = $(e.target)
      if (self.attr('aria-expanded') === 'true' && !target.is(self) && !$.contains(self.get(0), target.get(0))) {
        self.attr('aria-expanded', 'false')
      }
    }
  }

  self.changed = function(e) {
    if (self.selected) {
      let labelValue = self.find(':input:checked').parent().find('span').text()
      self.selected.text(labelValue)
      self.clicked()
    }
    if (self.value != self.find(':input:checked').val()) {
      self.value = self.find(':input:checked').val()
      self.trigger('value_changed')
    }
  }

  self.val = function() {
    return self.find(':input:checked').val()
  }

  return function() {
    self.BlockElement()
    self.initialize_dropdown()
    self.data('section-sort', self)
    return self
  }()
}

$.fn.SectionToolbar = function(grid, lists) {
  let self = this

  self.tools = {
    filters: self.find('.section-filters').SectionFilter(),
    sort: self.find('.section-sort').SectionSort(),
  }

  self.changed = function(e) {
    if (grid != undefined) {
      grid.filter_grid(self.tools.filters.val(), self.tools.sort.val())
    }
    if (lists != undefined) {
      lists.filter_lists(self.tools.filters.val(), self.tools.sort.val())
    }
  }

  self.open_filters = function() {
    self.find('.section-toolbar__filters-wrapper').fadeIn(175)
  }

  self.close_filters = function() {
    self.find('.section-toolbar__filters-wrapper').fadeOut(175)
  }

  return function() {
    self.tools.filters.on('value_changed', self.changed)
    self.tools.sort.on('value_changed', self.changed)
    self.find('.section-toolbar__filters-btn').on('click', self.open_filters)
    self.find('.section-toolbar__close-filters-btn').on('click', self.close_filters)
    return self
  }()
}

$.fn.SectionGridItem = function(grid, index) {
  let self = this
  if (self.data('item')) {
    return self.data('item')
  }
  self.card = self.find('.card-' + grid.type).BlockElement()
  self.filters = self.card.data('filters')

  self.has_filter = function(filter) {
    if (filter == 'all') {
      return true
    }
    return $.inArray(filter, self.filters) !== -1
  }

  return function() {
    self.BlockElement()
    if (index == 0) {
      self.addModifier('first')
    }
    self.attr('data-title', self.find('.card-' + grid.type + '__title').text())
    self.attr('data-publish', self.find('.card-' + grid.type).attr('data-publish'))
    self.data('item', self)
    self.card.PositionHover()
    return self
  }()
}

$.fn.SectionGrid = function() {
  let self = this
  self.isotope = undefined
  self.items = []
  self.type = self.hasClass('grid--style--panorama') ? 'panorama' : 'portfolio'

  self.init_items = function() {
    self.find('.grid__item').each(function(index) {
      let item = $(this).SectionGridItem(self, index)
      self.items.push(item)
    })
  }

  self.after_intro = function() {
    $('body').off('intro_played', self.after_intro)
    if (self.parents('.panel--status-opened').length) {
      self.hide()
    }
    setTimeout(function() {
      if (self.parents('.panel--status-opened').length) {
        self.fadeIn('fast')
      }
      self.isotope.arrange({
        transitionDuration: 0,
      })
    }, 350)
  }

  self.after_transition = function() {
    requestAnimationFrame(function() {
      self.isotope.arrange({
        transitionDuration: 0,
      })
    })
  }

  self.init_isotope = function() {
    self.isotope = new Isotope(self.get(0), {
      itemSelector: '.grid__item',
      layoutMode: 'masonry',
      masonry: {
        columnWidth: '.grid-sizer',
        gutter: '.gutter-sizer',
        transitionDuration: 0,
        percentPosition: false,
      },
      getSortData: {
        'a-z': '[data-title]',
        'z-a': '[data-title]',
        'recent': '[data-publish]',
        'ancien': '[data-publish]',
      },
    })
    $('body').on('intro_played', self.after_intro)
    $('.panels').on('transition_ended', self.after_transition)
  }

  self.filter_grid = function(filtering, sorting) {
    let options = {
      transitionDuration: 400,
      filter: function(index, item) {
        item = $(item).data('item')
        let has_filter = item.has_filter(filtering)
        if (has_filter) {
          item.removeClass('grid__item--first')
        } else {
          item.addClass('grid__item--first')
        }
        return has_filter
      },
    }
    if (sorting != 'random') {
      options.sortBy = sorting
      options.sortAscending = $.inArray(sorting, ['a-z', 'ancien']) !== -1
    }
    self.isotope.arrange(options)
    if (sorting == 'random') {
      self.isotope.shuffle()
    }
  }

  return function() {
    self.init_items()
    self.init_isotope()
    return self
  }()
}

export default {
  init() {
    let portfolioToolbar, portfolioGrid, panoramaToolbar, panoramaGrid, panoramaLists

    /* Portfolio */
    $('.grid--style--portfolio').each(function() {
      portfolioGrid = $(this).SectionGrid()
    })
    $('.panel--portfolio .section-toolbar').each(function() {
      portfolioToolbar = $(this).SectionToolbar(portfolioGrid)
    })

    /* Panorama */
    $('.grid--style--panorama').each(function() {
      panoramaGrid = $(this).SectionGrid()
    })
    $('.panorama-lists').each(function() {
      panoramaLists = $(this).PanoramaLists()
    })
    $('.panel--panorama .section-toolbar').each(function() {
      panoramaToolbar = $(this).SectionToolbar(panoramaGrid, panoramaLists)
    })
  },
}
